<template>
  <span>
      <label :class="{'on-error':onError}" class="pure-material-textfield-outlined">
            <select 
                :autocomplete="autocomplete" 
                :name="name"
                :id="id"
                
                :value="value"
                @change="$emit('change',$event.target.value)"
            >
                <option selected disabled value="">Select your {{placeholder}}</option>
                <option
                    v-for="(option,index) in options"
                    :key="index"
                    :value="option[valueName]"
                >{{option[keyName]}}</option>
                
            </select>
            <span>{{placeholder}}</span>
        </label>

        <div class="error-wrp">
            <small
                v-for="(value,key) in errors"
                :key="key"
                v-show="value"
            >{{key}}</small>
        </div>

  </span>
</template>

<script>
export default {
    
    props:{
        id:String,
        name:String,
        autocomplete:String,
        placeholder:String,
        options:Array,
        errors:Object,
        onError:Boolean,
        value:String,
        keyName:String,
        valueName:String,
    }
}
</script>

<style scoped>
.error-wrp{
    min-height: 16px;
    display: flex;
    flex-direction: column;
}

.error-wrp small{
    color: #f66;
}

.pure-material-textfield-outlined {
    width: 100%;
    position: relative;
    display: inline-block;
    padding-top: 6px;
    font-size: 17px;
    line-height: 1.5;
    /* overflow: hidden; */
    font-weight: 300;
    color: #707070;
    height: 56px;
    border: 1px solid var(--gold_outline);
    border-radius: 0;
    background: #fff;
    border-top-color: transparent;
}

/* Select */
.pure-material-textfield-outlined > select {
    padding-bottom: 7px;
    font-size: 17px;
    font-weight: 300;
    color: #707070;
    font-weight: 300;
    width: 100%;
    height: 100%;
    background: #fff;
    border: 0;
    background-image: url(/img/grey_arrow_down.svg);
    background-repeat: no-repeat;
    background-position: calc(100% - 21px) center;
    padding-right: 17px;
    padding-left: 17px;
    background-size: 11px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.pure-material-textfield-outlined.on-error{
    border-color: #f66;
    border-top-color: transparent;
}

/* Span */
.pure-material-textfield-outlined > select + span {
    position: absolute;
    top: -7px;
    left: 0;
    display: flex;
    border-color: var(--gold_outline);
    width: 100%;
    max-height: 100%;
    font-size: 75%;
    line-height: 15px;
    transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > select + span::before,
.pure-material-textfield-outlined > select + span::after {
    content: "";
    display: block;
    box-sizing: border-box;
    margin-top: 6px;
    border-top: solid 1px;
    border-top-color: var(--gold_outline);
    min-width: 10px;
    height: 8px;
    pointer-events: none;
    box-shadow: inset 0 1px transparent;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined.on-error > select + span::before,
.pure-material-textfield-outlined.on-error > select + span::after{
    border-top-color: #f66;
}

.pure-material-textfield-outlined > select + span::before{
    margin-right: 4px;
    border-left: solid 1px transparent;
}

.pure-material-textfield-outlined > select + span::after {
    flex-grow: 1;
    margin-left: 4px;
    border-right: solid 1px transparent;
}

/* Hover */
.pure-material-textfield-outlined:hover {
    border-color: var(--gold);
    border-top-color: transparent;
}

.pure-material-textfield-outlined:hover > select + span::before,
.pure-material-textfield-outlined:hover > select + span::after{
    border-top-color: var(--gold);
}

/* .pure-material-textfield-outlined:hover > select:not(:focus):placeholder-shown,
.pure-material-textfield-outlined:hover > textarea:not(:focus):placeholder-shown {
    border-color: var(--gold);
} */


/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution:.001dpcm) {
    @supports (-webkit-appearance:none) {
        .pure-material-textfield-outlined > select,
        .pure-material-textfield-outlined > select + span,
        .pure-material-textfield-outlined > select + span::before,
        .pure-material-textfield-outlined > select + span::after{
            transition-duration: 0.1s;
        }
    }
}

@media only screen and (max-width: 959px) {
    .pure-material-textfield-outlined{
        font-size: 14px;
        height: 45px;
    }

    .pure-material-textfield-outlined > select{
        font-size: 14px;
    }

}
</style>


// WEBPACK FOOTER //
// resources/js/components/partials/CustomSelect.vue